import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";
import "../../styles/components/slices/staff_section.scss";

import info from "../../../static/images/general/info.svg";
import linkedIn from "../../../static/images/general/linked-in.svg";

const MyVerticallyCenteredModal = ({ show, onHide, items, index }) => {
  const item = items[index];

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="descr-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="descr-modal">
          <div className="d-flex flex-column">
            <h3 className="name mb-0">{item ? item.name : ""}</h3>
            <span className="job-title">{item ? item.job_title : ""}</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PrismicRichText field={item ? item.description.richText : ""} />
      </Modal.Body>
    </Modal>
  );
};

const StaffSection = ({ slice }) => {
  if (!slice) return null;

  const [modalShow, setModalShow] = React.useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(null);

  const handleShowModal = (index) => {
    setSelectedItemIndex(index);
    setModalShow(true);
  };

  const handleCloseModal = () => {
    setSelectedItemIndex(null);
    setModalShow(false);
  };

  return (
    <Container fluid className="staff-section">
      <Container className="max-container p-0">
        <Row>
          <h2 className="mb-2 text-center title-65">
            {slice.primary.title1.text}
          </h2>
        </Row>
        <Row className="justify-content-center mt-2 mb-5">
          <Col md={8} className="text-center col-12">
            <PrismicRichText field={slice.primary.description.richText} />
          </Col>
        </Row>
        <Row xs={1} md={3} className="g-4 justify-content-center">
          {slice.items.map((item, idx) => (
            <Col key={item.image.url}>
              <Card>
                <Card.Img variant="top" src={item.image.url} />
                <Card.ImgOverlay>
                  <div className="icons">
                    <div className="d-flex">
                      <div
                        tabIndex={0}
                        role="button"
                        onClick={() => handleShowModal(idx)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleShowModal(idx);
                          }
                        }}
                      >
                        <img src={info} alt="info icon" className="info me-3" />
                      </div>
                      <Anchor href={item.linkedin_link.url} target="_blank">
                        <img
                          src={linkedIn}
                          alt="linked in icon"
                          className="linked-in ms-3"
                        />
                      </Anchor>
                    </div>
                  </div>
                </Card.ImgOverlay>
                <Card.Body>
                  <Card.Title>{item.name}</Card.Title>
                  <Card.Text>{item.job_title}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={handleCloseModal}
          items={slice.items}
          index={selectedItemIndex}
        />
      </Container>
    </Container>
  );
};

export default StaffSection;
